<template>
  <zeit-prompt v-if="showPrompt" @close="hidePrompt()" ref="prompt" desktopCloseLabel="Schließen" maxWidth="max-w-2xl">
    <template #title>Hinweise zu deinem Abonnement</template>   

    <div class="flex flex-col mb-8 mt-4">
      <p class="mb-6">
        Deine <strong>{{ details.plan }}-Lizenz</strong> läuft in <span class="font-semibold">{{ timeUntil(details?.next_renewal_date, true).days }} Tagen</span> ab.
        Um nahtlos weiterarbeiten zu können, bitten wir dich, deine Zahlungsdaten zu hinterlegen.
        Das kannst du ganz einfach in deinem Account unter <router-link @click="showPrompt = false" :to="{name: 'billing'}" class="text-primary-dark font-semibold">Abonnements &amp; Rechnungen</router-link> erledigen.
      </p>

      

      <ul class="list-disc list-outside ml-5 mb-4">
        <li class="mb-4">Ohne hinterlegte Zahlungsdaten wechselst du am <strong>{{ formatDatetime(details?.next_renewal_date) }}</strong> in den kostenfreien {{ details.next_plan_label }}-Plan.</li>
        <li class="mb-4">An diesem Tag werden alle Mitarbeiter bis auf die ersten fünf archiviert und die Terminals aus deinem Konto entfernt.</li>
        <li class="mb-4">Nach weiteren 90 Tagen ohne erfasster Arbeitszeit wird dein Konto gelöscht.</li>
      </ul>

      <div class="mb-4">
        Falls du Fragen hast oder Unterstützung benötigst, melde dich gerne bei unserem <router-link @click="showPrompt = false" :to="{name: 'support'}" class="text-primary-dark font-semibold">Support-Team</router-link>.
      </div>

      <div class="mb-2">Dieser Hinweis wird dir einmalig pro Tag angezeigt.</div>
    </div>

    <template #additionalButtons>
      <zeit-button @click="changePaymentMethod()" color="primary" fill="full" class="mx-2">Zahlungsdaten hinterlegen &amp; Plan wählen &rarr;</zeit-button>
    </template>
  </zeit-prompt>
</template>
  
<script lang="ts">
  import { defineComponent } from 'vue';

  import ZeitCard from '@/components/ui/v2/ZeitCard.vue';
  import ZeitCardItem from '@/components/ui/v2/ZeitCardItem.vue';
  import ZeitPrompt from '@/components/ui/ZeitPrompt.vue';
  import ZeitButton from '@/components/ui/v2/ZeitButton.vue';
  import { session } from '@/globals/session';
  import { formatDatetime, timeUntil } from '@/globals/helpers';
  import brand from '@/branding';

  import { SubscriptionDetails } from '@/services/billing';
  import billingService from '@/services/billing';

  export default defineComponent({
    components: {
      ZeitCard, ZeitCardItem, ZeitPrompt, ZeitButton,
    },
    data() {
      return {
        showPrompt: false,
        account: session.account,
        details: undefined as SubscriptionDetails|undefined,
      }
    },
    setup() {
      return {
        formatDatetime,
        timeUntil,
        brand,
      }
    },
    methods: {
      hidePrompt() {
        this.showPrompt = true;
        localStorage.setItem('switchToBasicPrompt', new Date().toISOString());
      },
      changePaymentMethod() {
        this.showPrompt = false;
        this.$router.push({ name: 'billing' });
      },
    },
    async mounted() {
      if (brand.id != 'red') return;
      if (session.account?.role != 'admin') return;

      // The axios response interceptor returns undefined on Network Error (see src/axios.ts).
      const response = await billingService.subscriptionDetails();
      if (!response) return;
      this.details = response.data;

      if (this.details.plan_id == 'basic') return;
      if (this.details.next_plan_id != 'basic' && this.details.has_payment_method) return;

      if (timeUntil(this.details.next_renewal_date, true).days > 10) return;

      const lastPrompt = localStorage.getItem('switchToBasicPrompt');
      if (lastPrompt && new Date(lastPrompt).getDate() == new Date().getDate()) return;      

      this.showPrompt = true;
    },
  })
</script>
